const breadCrumb = "Lotação de Servidores - Manutenção de Informações Servidor";

const routes = [
  {
    path: "/parametrizacao-do-periodo-para-solicitacao-de-remocao",
    name: "parametrizacao-do-periodo-para-solicitacao-de-remocao",
    meta: {
      allowedPermissions: ["parametro_periodo_remocao_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoDeInformacoesDoServidor/RemocaoDoServidor/ParametrizacaoDoPeriodoParaSolicitacaoDeRemocao/ParametrizacaoDoPeriodoParaSolicitacaoDeRemocaoHome.vue"
      ),
  },
  {
    path: "/parametrizacao-do-periodo-para-solicitacao-de-remocao/novo",
    name: "parametrizacao-do-periodo-para-solicitacao-de-remocao-novo",
    meta: {
      allowedPermissions: ["parametro_periodo_remocao_insert"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoDeInformacoesDoServidor/RemocaoDoServidor/ParametrizacaoDoPeriodoParaSolicitacaoDeRemocao/ParametrizacaoDoPeriodoParaSolicitacaoDeRemocaoCad.vue"
      ),
  },
  {
    path: "/parametrizacao-do-periodo-para-solicitacao-de-remocao/editar/:id",
    name: "parametrizacao-do-periodo-para-solicitacao-de-remocao-editar",
    meta: {
      allowedPermissions: ["parametro_periodo_remocao_update"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/ManutencaoDeInformacoesDoServidor/RemocaoDoServidor/ParametrizacaoDoPeriodoParaSolicitacaoDeRemocao/ParametrizacaoDoPeriodoParaSolicitacaoDeRemocaoEdit.vue"
      ),
  },
];

export default routes;
